module.exports = __webpack_public_path__ + "static/media/mc_frontview_base.5621976c.svg";